import type { FormField } from '@cli-types/core-engine/schema.js'
import { renderAdminSubmissionDrawerRenderer } from '@next-adapter/templates/renderers/generators/form-admin/admin-submission-drawer.js'

export function generateSubmissionDrawer(
  pascal: string,
  kebab: string,
  fields: FormField[],
  label: string,
  includeDynamic: boolean,
  _actionImportPath: string
): string {
  const fieldItems = fields
    .filter((f) => f.name)
    .map((f) => {
      const name = f.name!
      const lbl = f.label

      if (f.type === 'email') {
        return renderAdminSubmissionDrawerRenderer({
          kind: 'renderSubmissionDrawerEmailField',
          props: { lbl: lbl, name: name }
        })
      }
      if (f.type === 'textarea') {
        return renderAdminSubmissionDrawerRenderer({
          kind: 'renderSubmissionDrawerMultilineField',
          props: { lbl: lbl, name: name }
        })
      }
      if (f.type === 'checkbox') {
        return renderAdminSubmissionDrawerRenderer({
          kind: 'renderSubmissionDrawerBooleanField',
          props: {
            lbl: lbl,
            name: name
          }
        })
      }
      if (f.type === 'date') {
        return renderAdminSubmissionDrawerRenderer({
          kind: 'renderSubmissionDrawerDateField',
          props: {
            lbl: lbl,
            name: name
          }
        })
      }
      if (f.type === 'url') {
        return renderAdminSubmissionDrawerRenderer({
          kind: 'renderSubmissionDrawerUrlField',
          props: {
            lbl: lbl,
            name: name
          }
        })
      }
      if (f.type === 'list' || f.type === 'multiselect') {
        return renderAdminSubmissionDrawerRenderer({
          kind: 'renderSubmissionDrawerListField',
          props: {
            lbl: lbl,
            name: name
          }
        })
      }
      return renderAdminSubmissionDrawerRenderer({
        kind: 'renderSubmissionDrawerValueField',
        props: {
          lbl: lbl,
          name: name
        }
      })
    })
    .join('\n')

  const customFieldsSection = includeDynamic
    ? renderAdminSubmissionDrawerRenderer({
        kind: 'renderSubmissionDrawerCustomFieldsSection'
      })
    : ''

  return renderAdminSubmissionDrawerRenderer({
    kind: 'renderSubmissionDrawer',
    props: {
      pascal: pascal,
      kebab: kebab,
      label: label,
      fieldItems: fieldItems,
      customFieldsSection: customFieldsSection
    }
  })
}
